import { createSelector } from 'reselect';

import { noneOption } from 'constants/options';
import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const getCompanyLeadSources = createSelector(getCompany, ({ leadSources }) => leadSources);

export const selectCompanyLeadSourcesValues = createSelector(getCompanyLeadSources, Object.values);

export const selectCompanyLeadSourcesOptions = createSelector(
  selectCompanyLeadSourcesValues,
  leadSourcesValues => {
    const leadSourcesOptions = leadSourcesValues.map(({ leadSourceId, sourceName }) => ({
      value: leadSourceId,
      name: sourceName,
    }));

    return [noneOption, ...leadSourcesOptions];
  },
);

export const getFilteredCompanyLeadSources = createSelector(
  getDebouncedSearchValue,
  selectCompanyLeadSourcesValues,
  searchItems(leadSource => [leadSource.sourceName]),
);
